// This function determines the parent origin to handle cases where the app is embedded in an iframe
export function getParentOrigin(): string {
  const parentIframeUrl = process.env.REACT_APP_PARENT_IFRAME_URL;
  if (parentIframeUrl && parentIframeUrl.trim() !== '') {
    return parentIframeUrl;
  }
  return window.location.origin;
}